import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';

interface UnsupportedBrowserBannerProps {
  setShow: (show: boolean) => void;
}

const UnsupportedBrowserBanner = ({ setShow }: UnsupportedBrowserBannerProps) => {
  const handleOnClose = () => {
    try {
      localStorage.setItem('unsupportedBrowserBannerDismissed', 'true');
    } catch {
      // ignore storage errors
    }
    setShow(false);
  };

  return (
    <Alert
      role="alert"
      aria-live="polite"
      severity="warning"
      onClose={handleOnClose}
      sx={{
        position: 'fixed',
        right: 16,
        bottom: 16,
        maxWidth: 420,
        zIndex: 1400,
        boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
        borderRadius: 1,
        backgroundColor: 'warning.light',
        border: '1px solid',
        borderColor: 'warning.main',
        color: 'warning.dark',
        '& .MuiAlert-icon': { color: 'warning.dark' }
      }}
    >
      <Typography variant="subtitle1">Your browser may not be supported.</Typography>
      <Typography variant="subtitle2">
        For the best experience, please update your browser or switch to a device with an updated version of this browser.
      </Typography>
      <Typography variant="subtitle2">Some features may not work as expected.</Typography>
    </Alert>
  );
};

export default UnsupportedBrowserBanner;
